/* eslint-disable no-empty */

import { AxiosError } from "axios";

import { LogOperation } from "../../utils/entities/logOperation";
import api from "../api";
import { IPaginatedParams, postUnitBody } from "../interface";
import { returnResponse } from "../utils";

export const AttendantService = {
  getAllPaginated: async (params: IPaginatedParams) => {
    try {
      const { pageNumber, pageSize, searchTerm, active } = params;
      const queryParams = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
      });
      if (active !== undefined && active !== 2) {
        queryParams.append("active", String(active));
      }
      if (searchTerm) {
        queryParams.append("searchTerm", searchTerm);
      }
      return await api.get<any>(
        `/v1/Attendant/GetAllByCustomerId?${queryParams.toString()}`,
        { timeout: 10000 },
      );
    } catch (error) {
      console.error("Erro ao buscar os participantes:", error);
      throw error;
    }
  },

  getAllUserCoustomer: async (customerId: number, active?: number) => {
    if (active !== 2) {
      return await api.get<any>(
        `/v1/UserCustomer/GetAll?customerId=${customerId}&active=${active}`,
      );
    } else {
      return await api.get<any>(
        `/v1/UserCustomer/GetAll?customerId=${customerId}`,
      );
    }
  },

  getAllUserCustomerByCpfEmailOrName: async (searchTerm: string) => {
    return await api.get<any>(
      `/v1/UserCustomer/GetAllByCpfEmailOrName?searchTerm=${encodeURIComponent(
        searchTerm,
      )}`,
    );
  },

  getAllByCostumerId: async (customerId: number, active?: number) => {
    try {
      const config = {
        timeout: 10000,
      };
      if (active !== 2) {
        return await api.get<any>(
          `/v1/Attendant/GetAllByCustomerId?customerId=${customerId}&active=${active}`,
          config,
        );
      } else {
        return await api.get<any>(
          `/v1/Attendant/GetAllByCustomerId?customerId=${customerId}`,
          config,
        );
      }
    } catch (error) {
      console.error("Erro ao buscar os participantes:", error);
      throw error;
    }
  },
  getAllByHearingFileType: async ({
    hearingId,
    hearingFileTypeId,
  }: {
    hearingId: number;
    hearingFileTypeId: number;
  }) => {
    const { data } = await api.get<any>(
      `/v1/Attendant/GetAllByHearingFileType?hearingId=${hearingId}&hearingFileTypeId=${hearingFileTypeId}`,
    );

    return {
      status: true,
      data: data,
    };
  },
  postNewAttendant: async (payload: any) => {
    return await api.post<any>(`/v1/Attendant/Add`, payload);
  },
  putNewAtendant: async (payload: any) => {
    return await api.put<any>(`/v1/Attendant/Update`, payload);
  },
  deleteAttendant: async (id: number) => {
    return await api.delete<any>(`/v1/Attendant/Delete?id=${id}`);
  },

  removeUnit: async (id: number) => {
    return await api.delete<any>(`/v1//UserCustomerPlace/Delete?id=${id}`);
  },

  upDate: async (body: any, userId: number) => {
    try {
      const { data } = await api.put<any>(
        `/v1/UserCustomer/Update?id=${userId}`,
        body,
      );

      return {
        status: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  put: async (userUnit: any) => {
    try {
      const body = {
        ...userUnit,
      };
      const { data } = await api.put<any>(`/v1/UserCustomerPlace/Update`, body);

      return {
        status: true,
        data: data,
      };
    } catch (error: any) {
      return {
        status: false,
        data: error.response,
      };
    }
  },

  putUnit: async (registerId: number, value: boolean) => {
    try {
      const body = [
        {
          op: "replace",
          value: value,
          path: "active",
        },
      ];

      const { data } = await api.patch(
        `/v1/UserCustomerPlace/Update?id=${registerId}`,
        body,
      );

      return {
        status: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
  post: async (UserUnit: any) => {
    try {
      const body = {
        ...UserUnit,
      };
      const { data } = await api.post<any>(`/v1/UserCustomer/Add`, body);

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message:
            error?.response?.data?.message ??
            error?.response?.data?.errors?.[0]?.message,
        });

        return {
          severity,
          status,
          message: message ?? "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
  postUnit: async (unitList: postUnitBody[]) => {
    try {
      const { data } = await api.post<any>(
        `/v1/UserCustomerPlace/AddAll`,
        unitList,
      );

      return {
        status: true,
        data: data,
      };
    } catch (error: any) {
      throw {
        status: false,
        data: error.response?.data,
      };
    }
  },

  postUnitUnique: async (unitList: any) => {
    try {
      const { data } = await api.post<any>(
        `/v1/UserCustomerPlace/Add`,
        unitList,
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {}
  },
};

interface IVinculeAttendant {
  attendantRoleId: number | undefined;
  attendantId: number;
  hearingId: string;
  device: string;
  ip: string;
  logPoliceUnitId: number;
  logUserId: number;
  token: string;
  link: string;
  id: number;
  used: number;
  attempts: number;
}

interface ResponseTypeVincule {
  status: boolean;
  message: string;
  severity: string;
  data: null;
}

export const AttendandoViculeService = {
  vincule: async (body: IVinculeAttendant): Promise<ResponseTypeVincule> => {
    try {
      const { data } = await api.post("/v1/HearingAttendant/Add", body);

      return {
        status: true,
        message: data.data.message,
        data: data.data,
        severity: "success",
      };
    } catch (error: any) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Sucesso",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
};

export const procedureCustomerAttendantService = {
  unbinding: async (procedureCustomerAttendantId: number) => {
    try {
      const { data } = await api.delete(
        `/v1/HearingAttendant/Delete?id=${procedureCustomerAttendantId}`,
      );
      await LogOperation.postLogOperation("HearingAttendant", 3, 3);
      return {
        success: true,
        body: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: error?.response?.data.message,
        });

        return {
          success: false,
          severity,
          status,
          body: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  // getAttendantByProcedureRoleType: async ({
  //   hearingId,
  // }: {
  //   hearingId: number;
  // }) => {
  //   try {
  //     const { data } = await api.get(
  //       `/v1/HearingAttendant/GetAllAttendantInfoByHearingId?hearingId=${hearingId}`
  //     );
  //     return {
  //       success: true,
  //       body: data.data,
  //     };
  //   } catch (error) {
  //     return {
  //       success: false,
  //       body: {},
  //     };
  //   }
  // },

  // getAllToBindByHearingId: async ({ hearingId }: { hearingId: number }) => {
  //   // eslint-disable-next-line no-useless-catch
  //   try {
  //     const { data } = await api.get(
  //       `/v1/Attendant/GetAllToBindByHearingId?hearingId=${hearingId}`
  //     );
  //     return {
  //       status: true,
  //       data: data,
  //     };
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  GetAllByNameOrDocument: async ({
    searchTerm,
    globalSearch,
  }: {
    customerId?: number;
    searchTerm: string;
    globalSearch: boolean;
  }) => {
    const { data } = await api.get(
      `/v1/Attendant/GetAllByNameOrDocument?active=1&searchTerm=${encodeURIComponent(
        searchTerm,
      )}&globalSearch=${globalSearch}`,
    );
    return {
      status: true,
      data: data,
    };
  },
};
